import type { FaireProductEntity } from "../../entity_types/product";

export const p_h4s9du8kvb: FaireProductEntity = {
  token: "p_h4s9du8kvb",
  type: "product",
  name: "Hard to Sketch Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/9905e59569b92664b8e051bee9c11d0d10e72c8a87b19454e7c81936d0b98c65.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b746f69624bc89b4aa61db3b2136f5dc68a57c98fec91f5f696b87bacc49fa6d.jpeg",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:34.193Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
